export default __webpack_public_path__ + "assets/7bfd706b4fbca017b2d90f599de717de.png";